import { useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

type Props = {
  onClose?: () => void;
};

export default function Modal(props: React.PropsWithChildren<Props>) {
  const [el] = useState(() => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("modal-wrapper");
    return wrapper;
  });

  const close = (evt: React.MouseEvent | KeyboardEvent) => {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    if (props.onClose) {
      props.onClose();
    }
  };

  const handleKeypress = (evt: KeyboardEvent) => {
    if (evt.which == 27) {
      close(evt);
    }
  };

  useLayoutEffect(() => {
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeypress);
    return () => {
      document.removeEventListener("keydown", handleKeypress);
    };
  });

  return createPortal(
    <>
      <div className="modal-background" onClick={close} />
      <div className="inner">
        <div className="modal-content">{props.children}</div>
      </div>
    </>,
    el
  );
}
